import React from "react";
import PropTypes from "prop-types";
import ProductItem, {ViewMode as ProductItemViewMode} from './ProductItem';
import "./ProductItems.style.scss";

const ProductItems = ({ products, onProductSelected, vm }) => {
    if(!products)
        return null;
    return (
        <div className="ProductItems asButtonsGrid">
            <div>
                {products.map((p) => {
                    return (
                        <ProductItem
                            key={"product" + p.productId}
                            product={p} //Custom
                            viewMode={ p.name === "Other" ? ProductItemViewMode.CUSTOM : ProductItemViewMode.AS_BUTTON }
                            isSelected={ p.productId === vm.selectedProduct?.productId }
                            onProductSelected={onProductSelected}
                        />
                    );
                })}
            </div>
        </div>
    );
}

ProductItems.propTypes = {
    products: PropTypes.any,
    onProductSelected: PropTypes.func,
};

export default ProductItems;